import { render, staticRenderFns } from "./ContentTypePerson.vue?vue&type=template&id=7aa8a68d&scoped=true&"
import script from "./ContentTypePerson.vue?vue&type=script&lang=js&"
export * from "./ContentTypePerson.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypePerson.vue?vue&type=style&index=0&id=7aa8a68d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8a68d",
  null
  
)

export default component.exports